module.exports = __webpack_public_path__ + "img/cj_bg.1435dd2f.png";